import React, { Component } from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'

import {
  fetchHomepageIfNeeded,
  fetchSubscriberOverviewIfNeeded,
  fetchSubscriberGenreTitleIfNeeded,
  setSelectedNetwork,
  setSelectedNetworkType,
  setSelectedSidebarNav,
  setCatalogSelectedMetricDateIfNeeded,
  logout
} from '../../actions'
import {
  makeSubscriberIdSelector,
  makeCatalogOverviewDetailsSelector,
  makeCatalogGenreTitleDetailsSelector,
  makeSubscriberWhatsNewSelector
} from '../../selectors'
import SubscriberComponent from '../../components/subscriber/SubscriberComponent'
import SidebarComponent from '../../components/sidebar/SidebarComponent'
import Profile from '../../classes/profile'
import { LS_HOMEPAGE_KEY } from '../../constants/local_storage'
import GoogleAnalytics from '../../classes/GoogleAnalytics'
import { SUBSCRIBER_OVERVIEW_MODULE } from '../../constants/commons'

import CatalogOverview from '../../testsupport/apiresults/CatalogOverview.json'
import { catalogYearOptions } from '../../constants/options'

export class SubscriberContainer extends Component {
  static propTypes = {
    isAdmin: PropTypes.bool.isRequired,
    profile: Profile.PropTypes,
    history: PropTypes.object,
    match: PropTypes.object,
    subscriberId: PropTypes.string,
    subscriber: PropTypes.object,
    subscriberGenreTitle: PropTypes.object,
    subscriberCalendar: PropTypes.object,
    audienceAcquisition: PropTypes.object,
    logout: PropTypes.func.isRequired,
    location: PropTypes.object.isRequired,
    shortcut: PropTypes.shape({
      id: PropTypes.string.isRequired,
      expires_at: PropTypes.string.isRequired,
      target: PropTypes.string.isRequired,
      target_id: PropTypes.string.isRequired
    }),
    fetchHomepage: PropTypes.func.isRequired,
    fetchSubscriberOverview: PropTypes.func.isRequired,
    fetchGenreTitle: PropTypes.func.isRequired,
    setSelectedNetwork: PropTypes.func.isRequired,
    setSelectedNetworkType: PropTypes.func.isRequired,
    selectedSubscriberNetwork: PropTypes.string,
    selectedSubscriberNetworkType: PropTypes.string,
    selectedNav: PropTypes.string,
    isContentIntelligence: PropTypes.bool,
    isCatalogAnalysis: PropTypes.bool,
    isPerformanceAnalysis: PropTypes.bool,
    isAIInsights: PropTypes.bool,
    selectedSidebarNav: PropTypes.func,
    setSelectedMetricDate: PropTypes.func,
    selectedMetricDate: PropTypes.string
  }

  constructor (props) {
    super(props)

    this.state = {
      subscriber: {
        details: CatalogOverview,
        isFetching: false,
        error: false
      }
    }
  }

  componentDidMount () {
    GoogleAnalytics.trackGA(SUBSCRIBER_OVERVIEW_MODULE, this.props.location, this.props.profile)
    this.fetchData ()
  }

  componentDidUpdate (prevProps) {
    if (prevProps.subscriberId !== this.props.subscriberId && this.props.subscriberId) {
      this.fetchData ()
    }
  }

  fetchData = () => {
    const homepage = JSON.parse(localStorage.getItem(LS_HOMEPAGE_KEY))
    if (!homepage) {
      if (this.props.profile && this.props.profile.groups.length > 0) {
        const groups = this.props.profile.groups
        const groupName = groups.filter(group => group !== 'Admin')[0]
        this.props.fetchHomepage(groupName)
      }
    }
    const subscriberId = this.props.subscriberId
    if (subscriberId) {
      this.props.fetchSubscriberOverview(subscriberId, catalogYearOptions[1].value)
      this.props.fetchGenreTitle(subscriberId, catalogYearOptions[1].value)
    }
  }

  catalogOverviewYearChange = (metricDate) => {
    const subscriberId = this.props.subscriberId
    if (subscriberId) {
      this.props.fetchSubscriberOverview(subscriberId, metricDate)
      this.props.fetchGenreTitle(subscriberId, metricDate)
    }
  }

  render () {
    const { profile, location, shortcut, subscriber, subscriberGenreTitle, subscriberCalendar, selectedNav, isContentIntelligence, isCatalogAnalysis, isPerformanceAnalysis, isAIInsights, selectedMetricDate, setSelectedMetricDate } = this.props
    const homepage = JSON.parse(localStorage.getItem(LS_HOMEPAGE_KEY))
    const myLogout = () => this.props.logout()

    return (
      <>
        <SidebarComponent
          isAdmin={this.props.isAdmin}
          profile={profile}
          logout={myLogout}
          location={location}
          homepage={homepage}
          shortcut={shortcut}
          selectedSidebarNav={this.props.selectedSidebarNav}
          selectedNav={selectedNav}
          isContentIntelligence={isContentIntelligence}
          isCatalogAnalysis={isCatalogAnalysis}
          isPerformanceAnalysis={isPerformanceAnalysis}
          isAIInsights={isAIInsights}
        />
        <SubscriberComponent
          isAdmin={this.props.isAdmin}
          shortcut={shortcut}
          homepage={homepage}
          subscriber={subscriber}
          subscriberGenreTitle={subscriberGenreTitle}
          subscriberCalendar={subscriberCalendar}
          setSelectedMetricDate={setSelectedMetricDate}
          selectedMetricDate={selectedMetricDate}
          setSelectedNetwork={this.props.setSelectedNetwork}
          setSelectedNetworkType={this.props.setSelectedNetworkType}
          selectedSubscriberNetwork={this.props.selectedSubscriberNetwork}
          selectedSubscriberNetworkType={this.props.selectedSubscriberNetworkType}
          catalogOverviewYearChange={this.catalogOverviewYearChange}
        />
      </>
    )
  }
}

function mapStateToProps () {
  const subscriberIdSelector = makeSubscriberIdSelector()
  const subscriberCalendarSelector = makeSubscriberWhatsNewSelector()
  const catalogOverviewSelector = makeCatalogOverviewDetailsSelector()
  const catalogGenreTitleSelector = makeCatalogGenreTitleDetailsSelector()
  return (state, ownProps) => {
    const profile = state.user.profile && new Profile(state.user.profile)
    const isAdmin = state.user.isAdmin
    const shortcut = ownProps.shortcut
    const homepage = state.homepage.list
    const selectedNav = state.sidebar.selectedNav
    const isContentIntelligence = state.sidebar.isContentIntelligence
    const isCatalogAnalysis = state.sidebar.isCatalogAnalysis
    const isPerformanceAnalysis = state.sidebar.isPerformanceAnalysis
    const isAIInsights = state.sidebar.isAIInsights
    const subscriberId = subscriberIdSelector(state, ownProps)
    const selectedSubscriberNetwork = state.subscriber.selectedNetwork
    const subscriber = catalogOverviewSelector(state, ownProps)
    const subscriberGenreTitle = catalogGenreTitleSelector(state, ownProps) //state.subscriber.genreTitle
    const subscriberCalendar = subscriberCalendarSelector(state, ownProps)
    const selectedMetricDate = state.budgetSubscribers.selectedMetricDate
    return {
      isAdmin,
      profile,
      shortcut,
      homepage,
      subscriberId,
      subscriber,
      subscriberGenreTitle,
      subscriberCalendar,
      selectedSubscriberNetwork,
      selectedNav,
      isContentIntelligence,
      isCatalogAnalysis,
      isPerformanceAnalysis,
      isAIInsights,
      selectedMetricDate
    }
  }
}

function mapDispatchToProps (dispatch) {
  return {
    fetchHomepage: (groupName) => dispatch(fetchHomepageIfNeeded(groupName)),
    fetchSubscriberOverview: (subscriberId, metricDate) => dispatch(fetchSubscriberOverviewIfNeeded(subscriberId, metricDate)),
    fetchGenreTitle: (subscriberId, metricDate) => dispatch(fetchSubscriberGenreTitleIfNeeded(subscriberId, metricDate)),
    setSelectedNetwork: (network) => dispatch(setSelectedNetwork(network)),
    setSelectedNetworkType: (networkType) => dispatch(setSelectedNetworkType(networkType)),
    selectedSidebarNav: (nav) => dispatch(setSelectedSidebarNav(nav)),
    setSelectedMetricDate: (metricDate) => dispatch(setCatalogSelectedMetricDateIfNeeded(metricDate)),
    logout: () => dispatch(logout())
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(SubscriberContainer)
